import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface Tenant {
  id: string;
  name: string;
}

interface TenantState {
  current: Tenant;
  available: Tenant[];
}

const SEED_TENANTS: Tenant[] = [
  { id: "spinola-dev", name: "Luxfair Spinola Hotel" },
];

const initialState: TenantState = {
  current: SEED_TENANTS[0]!,
  available: SEED_TENANTS,
};

const slice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    switchTenant(state, action: PayloadAction<string>) {
      const found = state.available.find((t) => t.id === action.payload);
      if (found) state.current = found;
    },
    addTenant(state, action: PayloadAction<Tenant>) {
      state.available.push(action.payload);
    },
  },
});

export const { switchTenant, addTenant } = slice.actions;
export default slice.reducer;
